import { FC, PropsWithChildren } from "react";
import styles from "./Form.module.scss";

interface Props {
    label: string;
    id: string;
}

const FormItem: FC<PropsWithChildren & Props> = ({ children, label, id }) => {
    return (
        <div className={styles.item}>
            <label htmlFor={id}>{label}</label>
            {children}
        </div>
    );
};

export default FormItem;
